import GLightbox from 'glightbox';
const Flickity = require('flickity');


window.addEventListener('load', () => {
  GLightbox();

  var elem = document.querySelector('.film-carousel');
  if (!elem) return;
  new Flickity( elem, {
    cellSelector: '.film-carousel__item',
    cellAlign: 'left',
    prevNextButtons: false,
    contain: true,
  });
});

var navToggle = document.querySelector('.nav-toggle');
var nav = document.querySelector('.header__nav-primary');


if (navToggle && nav) {
    navToggle.addEventListener('click', function (ev) {
        ev.preventDefault();
        navToggle.classList.toggle('active');
        nav.classList.toggle('active');
    });

    window.addEventListener('click', function (ev) {
        if (ev.target.closest('.header__nav-primary') !== nav && ev.target.closest('.nav-toggle') !== navToggle) {
            navToggle.classList.remove('active');
            nav.classList.remove('active');
        }
    });

    window.addEventListener('touchstart', function (ev) {
        if (ev.target.closest('.header__nav-primary') !== nav && ev.target.closest('.nav-toggle') !== navToggle) {
            navToggle.classList.remove('active');
            nav.classList.remove('active');
        }
    });
}
